/** ---- smoothing helpers -------------------------------------------------- */

// Triangular weights of given odd length (e.g., len=5 -> [1,2,3,2,1])
export function triangularWeights(len) {
  if (len < 1) return [1];
  const n = len % 2 === 1 ? len : len + 1; // ensure odd
  const half = (n - 1) / 2;
  const w = [];
  for (let i = -half; i <= half; i++) w.push(half + 1 - Math.abs(i));
  const sum = w.reduce((a, b) => a + b, 0);
  return w.map((v) => v / sum);
}

// Smooth y-values with a triangular moving average window sized by seconds.
// Falls back gracefully if inputs are sparse/short.
export function smoothSeriesBySeconds(xs, ys, seconds = 0.6) {
  const n = Math.min(xs?.length ?? 0, ys?.length ?? 0);
  if (n === 0) return [];
  if (n < 5 || !Number.isFinite(xs[n - 1] - xs[0])) {
    // too short or degenerate -> just return raw as {x,y}
    return Array.from({ length: n }, (_, i) => ({ x: xs[i], y: ys[i] }));
  }

  const totalT = xs[n - 1] - xs[0];
  const avgDt = totalT > 0 ? totalT / (n - 1) : 0.05; // seconds/sample
  const winSamples = Math.max(3, Math.round(seconds / Math.max(avgDt, 1e-6)));
  const weights = triangularWeights(winSamples); // odd length guaranteed
  const half = (weights.length - 1) / 2;

  const out = new Array(n);
  for (let i = 0; i < n; i++) {
    let acc = 0;
    let wsum = 0;
    for (let k = -half; k <= half; k++) {
      const j = i + k;
      if (j >= 0 && j < n) {
        const w = weights[k + half];
        acc += w * ys[j];
        wsum += w;
      }
    }
    const y = wsum > 0 ? acc / wsum : ys[i];
    out[i] = { x: xs[i], y };
  }
  return out;
}
